import { render, staticRenderFns } from "./advertisment.vue?vue&type=template&id=ffad0260&scoped=true&"
import script from "./advertisment.vue?vue&type=script&lang=js&"
export * from "./advertisment.vue?vue&type=script&lang=js&"
import style0 from "./advertisment.vue?vue&type=style&index=0&id=ffad0260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffad0260",
  null
  
)

export default component.exports